import Spinner from '@/common/components/Spinner'
import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Separator } from '@/common/ui/separator'
import useQueryGetReturnLossById from '@/modules/promotion/api/hooks/useQueryGetReturnLossById'
import { format } from 'date-fns'
import { Eye, PencilIcon } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

interface ReturnLossModalProps {
	returnLossId: string
}

export const ReturnLossModal = ({ returnLossId }: ReturnLossModalProps) => {
	const [open, setOpen] = useState(false)
	const { data: returnLoss, isLoading } =
		useQueryGetReturnLossById(returnLossId)

	return (
		<>
			<Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
				<Eye className="h-4 w-4" />
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-[600px]">
					<DialogHeader>
						<DialogTitle>รายละเอียดคืนยอดเสีย</DialogTitle>
					</DialogHeader>

					{isLoading ? (
						<div className="flex items-center justify-center">
							<Spinner />
						</div>
					) : returnLoss ? (
						<div className="space-y-4">
							<div className="flex justify-between">
								<div>
									<h3 className="font-semibold">ชื่อ</h3>
									<p>{returnLoss.name}</p>
								</div>
								<Button variant="outline" size="icon">
									<Link to={`/operator/return-loss/${returnLossId}`}>
										<PencilIcon className="h-4 w-4" />
									</Link>
								</Button>
							</div>

							<Separator />
							<div>
								<h3 className="my-4 font-semibold">
									เปอร์เซ็นต์คืนของแต่ละประเภทเกม (0-100%)
								</h3>
								<div className="grid grid-cols-2 gap-4">
									<div>
										<p>
											FISHING:{' '}
											{returnLoss.creditRatio.FISHING.creditRatio !== null &&
											returnLoss.creditRatio.FISHING.creditRatio !== undefined
												? String(
														Number(
															(
																returnLoss.creditRatio.FISHING.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
										<p>
											สูงสุด: {returnLoss.creditRatio.FISHING.maxCreditAmount}
										</p>
									</div>
									<div>
										<p>
											SLOT:{' '}
											{returnLoss.creditRatio.SLOT.creditRatio !== null &&
											returnLoss.creditRatio.SLOT.creditRatio !== undefined
												? String(
														Number(
															(
																returnLoss.creditRatio.SLOT.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
										<p>สูงสุด: {returnLoss.creditRatio.SLOT.maxCreditAmount}</p>
									</div>
									<div>
										<p>
											LOTTO:{' '}
											{returnLoss.creditRatio.LOTTO.creditRatio !== null &&
											returnLoss.creditRatio.LOTTO.creditRatio !== undefined
												? String(
														Number(
															(
																returnLoss.creditRatio.LOTTO.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
										<p>
											สูงสุด: {returnLoss.creditRatio.LOTTO.maxCreditAmount}
										</p>
									</div>
									<div>
										<p>
											SPORT:{' '}
											{returnLoss.creditRatio.SPORT.creditRatio !== null &&
											returnLoss.creditRatio.SPORT.creditRatio !== undefined
												? String(
														Number(
															(
																returnLoss.creditRatio.SPORT.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
										<p>
											สูงสุด: {returnLoss.creditRatio.SPORT.maxCreditAmount}
										</p>
									</div>
									<div>
										<p>
											CASINO:{' '}
											{returnLoss.creditRatio.CASINO.creditRatio !== null &&
											returnLoss.creditRatio.CASINO.creditRatio !== undefined
												? String(
														Number(
															(
																returnLoss.creditRatio.CASINO.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
										<p>
											สูงสุด: {returnLoss.creditRatio.CASINO.maxCreditAmount}
										</p>
									</div>
								</div>
							</div>
							<Separator />
							<div>
								<h3 className="font-semibold">ระยะเวลา</h3>
								<p>
									{returnLoss.startDate &&
										format(new Date(returnLoss.startDate), 'dd/MM/yyyy')}{' '}
									-{' '}
									{returnLoss.endDate &&
										format(new Date(returnLoss.endDate), 'dd/MM/yyyy')}
								</p>
							</div>
							<div>
								<h3 className="font-semibold">รอบเทิร์น</h3>
								<p>{returnLoss.turnoverRound}</p>
							</div>

							<div className="flex justify-end gap-4 pt-4">
								<Button variant="outline" onClick={() => setOpen(false)}>
									ปิด
								</Button>
							</div>
						</div>
					) : null}
				</DialogContent>
			</Dialog>
		</>
	)
}
